import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import ToastStore from '@store/toast/ToastStore';
import ArchivingProfileActions from 'actions/ArchivingProfileActions';
import {Record, List} from 'immutable';

@immutableStore
class ArchivingProfileStore {
  constructor() {
    this.state = Record({
      archivingProfiles: List(),
      wasError: false,
      isLoading: false,
      isSaving: false,
    })();
    this.bindActions(ArchivingProfileActions);
  }

  fetchArchivingProfilesLoading() {
    this.setState({
      archivingProfiles: List(),
      isLoading: true,
      wasError: false,
    });
  }

  fetchArchivingProfilesSuccess(archivingProfiles) {
    this.setState({isLoading: false, archivingProfiles});
  }

  fetchArchivingProfilesError() {
    this.setState({isLoading: false, wasError: true});
  }

  saveSuccess() {
    this.setState({
      isSaving: false,
    });
    ToastStore.addToast({
      type: 'success',
      time: 2000,
      message: 'Archiving Profile Saved!',
    });
  }

  saveError(error) {
    console.error(error);
    this.setState({
      isSaving: false,
    });
    if (error.response.status !== 409) {
      ToastStore.addToast({
        type: 'error',
        message: 'There was a problem saving the archiving profile.',
      });
    }
  }

  sendCreateRequest() {
    this.setState({
      isSaving: true,
    });
  }

  sendUpdateRequest() {
    this.setState({
      isSaving: true,
    });
  }

  updateArchivingProfile(archivingProfile) {
    let archivingProfiles = this.state.archivingProfiles.filter(profile => !!profile.id);
    const index = this.state.archivingProfiles.findIndex(
      profile => profile.id === archivingProfile.id
    );
    archivingProfiles =
      index !== -1
        ? archivingProfiles.splice(index, 1, archivingProfile)
        : archivingProfiles.concat([archivingProfile]);

    this.setState({archivingProfiles});
  }
}

export {ArchivingProfileStore as ArchivingProfileStoreClass};
export default alt.createStore(ArchivingProfileStore, 'ArchivingProfileStore');
